import React from 'react';

import logo from '../../assets/images atp/Rise-To-The-Top.svg';

const SidebarHeader = () => {
  return (
    <div style={{ width: '185px', height: '106px' }}>
      <img alt='icon' src={logo} style={{ width: '100%', display: 'block' }} />
    </div>
  );
};

export default SidebarHeader;
